import { Trans } from "@lingui/macro";
import { Box, Typography, Button } from "@mui/material";
import { SlidingDrawer } from "@WahooFitness/redesignr";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";

function ResetPagesDrawer({
  handleCloseDrawer,
  handleReset,
  open,
}: {
  handleCloseDrawer: () => void;
  handleReset: () => void;
  open: boolean;
}) {
  const { globalBottomPadding, platform } = useConfigContext();

  return (
    <SlidingDrawer
      platform={platform}
      globalBottomPadding={globalBottomPadding}
      open={open}
      title=""
      hidePuller
      hideDivider
      hideHeader
      elevation={4}
      handleOpen={() => {}}
      handleClose={handleCloseDrawer}
    >
      <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="column" gap={1} alignItems="center" px={4} pb={3} pt={4}>
          <Typography variant="prose-lg-medium" textAlign="center">
            <Trans>Reset all pages to Wahoo default?</Trans>
          </Typography>
          <Typography variant="prose-base" textAlign="center">
            <Trans>Are you sure you want to reset all pages to the Wahoo default?</Trans>
          </Typography>
        </Box>

        <Box display="flex" flexDirection="row" p={3} gap={1.5}>
          <Button variant="outlined" size="large" fullWidth onClick={handleCloseDrawer}>
            <Trans>Keep</Trans>
          </Button>
          <Button color="error" variant="outlined" size="large" fullWidth onClick={handleReset}>
            <Trans>Reset</Trans>
          </Button>
        </Box>
      </Box>
    </SlidingDrawer>
  );
}

export default ResetPagesDrawer;
